import { getRequest, patchRequest, postRequest, deleteRequest } from './seviceHelpers';

export default {
    getMe: async () => getRequest('/users/me?include=team'),
    update: async payload => patchRequest(`/users/${payload.data.id}`, payload),
    updatePassword: async payload => postRequest('/users/me/password', payload),
    delete: async (payload, includeTeam) => deleteRequest(`/users/me${includeTeam ? '?include=team' : ''}`, payload),
};
